import { useSnackbar } from "notistack";
import { crudGetOne, EditBase, useEditContext } from "ra-core";
import { FC, useCallback } from "react";
import { useDispatch } from "react-redux";
import { crudGetOneEx } from "@/actions/crudFetchEx";
import useIdTokenUser from "@/authProvider/useIdTokenUser";
import { MutationCallbacks } from "@/dataProvider/types";
import { UserResponseDto } from "@/gen/api/user";
import { OdResourcePageProps } from "@/types/resource";
import chainOptions from "@/utils/chainOptions";
import { useResourceRegister } from "@/utils/resourceRegister";
import { ProfileFormValues } from "./Create";
import ProfileUpdateBody from "./UpdateBody";


export const ProfileUpdateCater: FC<OdResourcePageProps> = (props) => {
  const {
    record,
    save,
  } = useEditContext<UserResponseDto & { id: number }>();
  
  const idTokenUser = useIdTokenUser()
  const { enqueueSnackbar } = useSnackbar()

  const dispatch = useDispatch()
  
  const finalSave = useCallback(function(values: Partial<ProfileFormValues>, redirect, options: MutationCallbacks = {}) {
    if (save) {
      save(values, '', chainOptions(options, {
        onSuccess: () => {
          enqueueSnackbar('Update succeed', { variant: 'success' })
          dispatch(crudGetOneEx('profile', 'edit', ''))
        },
        onFailure: (err) => {
          enqueueSnackbar('Update failed', { variant: 'error' })
        },
      }))
    }
  }, [save, enqueueSnackbar])


  return (
    <ProfileUpdateBody 
      save={finalSave} 
      user={record}
      idTokenUser={idTokenUser}
      {...props} 
    />
  )
}

const ProfileUpdate: FC<OdResourcePageProps> = (props) => {
  useResourceRegister({ name: 'timezone-options' })
  
  return (
    <EditBase {...props} mutationMode={'pessimistic'} >
      <ProfileUpdateCater {...props} />
    </EditBase>
  )
}

export default ProfileUpdate;
